/**
 * Sprint 24.13 — owner-only prompt-cache health hook.
 *
 * Wraps `get_cache_health` for the /admin/cache-health dashboard. Owner-only at
 * the tool layer (ACL) and route layer (App.tsx guard). Cached 60s; refetches on
 * window focus so a returning owner sees fresh numbers.
 */

import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import { useAuth } from "../../lib/hooks/use-auth";
import { queryKeys } from "../../lib/query-keys";
import type { CacheHealthResult } from "../../lib/types";

export function useCacheHealth(days = 7, enabled = true) {
  const { currentWorkspaceId } = useAuth();
  return useQuery<CacheHealthResult>({
    queryKey: [...queryKeys.cacheHealth(days), currentWorkspaceId],
    queryFn: () => mcpClient.getCacheHealth(days),
    enabled: !!currentWorkspaceId && enabled,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
